import React from 'react';
import { Venue } from '../types';
import { Button, Flex, Text, Card } from './base-components';
import { useTranslation } from '../i18n/TranslationContext';

interface Props {
  venue: Venue;
  onSubscribe: (venue: Venue) => void;
}

export const VenueCard: React.FC<Props> = ({ venue, onSubscribe }) => {
  const { t } = useTranslation();
  return (
    <Card mb={4}>
      <Flex justify="between" align="center" gap={4}>
        <Flex direction="col">
          <Text variant="title" mb={1}>{venue.name}</Text>
          <Flex gap={2} align="center">
            <Text variant="muted">
              {[
                [venue.city, venue.state].filter(Boolean).join(', '),
                // 0 means unknown too; show nothing rather than a placeholder.
                venue.capacity ? `${t('venueCard.capacity')} ${venue.capacity}` : '',
              ].filter(Boolean).join(' · ')}
            </Text>
            {venue.venue_url && (
              <a
                href={venue.venue_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-[#3b82f6] hover:text-[#60a5fa] transition-colors"
              >
                View on DICE
              </a>
            )}
          </Flex>
        </Flex>
        <Button
          variant="primary"
          disabled={venue.is_subscribed}
          onClick={() => onSubscribe(venue)}
          whitespace="nowrap"
        >
          {venue.is_subscribed ? t('common.subscribed') : t('common.subscribe')}
        </Button>
      </Flex>
    </Card>
  );
};


